import { BebopUser, RegistrationState } from 'src/app/interfaces/user';

type AgreementType = 'terms' | 'privacy' | 'provision';

function isRegistrationState(value: unknown): value is RegistrationState {
  return (
    value === 'phone_verification_pending' ||
    value === 'profile_pending' ||
    value === 'agreements_pending' ||
    value === 'activation_pending' ||
    value === 'active'
  );
}

export function getPendingAgreementTypes(
  profile: Partial<BebopUser>,
  audienceHint?: string
): AgreementType[] {
  const audience = String(audienceHint || profile.dashboard || 'client').toLowerCase();
  const isWorker = audience === 'worker' || profile.is_worker === true;

  const missing: AgreementType[] = [];
  if (!profile.terms_agreed_to) {
    missing.push('terms');
  }

  if (!profile.privacy_agreed_to) {
    missing.push('privacy');
  }

  if (isWorker && !profile.provision_agreed_to) {
    missing.push('provision');
  }

  return missing;
}

export function getPrimaryPendingAgreementType(
  profile: Partial<BebopUser>,
  audienceHint?: string
): AgreementType | undefined {
  return getPendingAgreementTypes(profile, audienceHint)[0];
}

export function deriveRegistrationStateFromProfile(
  profile: Partial<BebopUser>,
  audienceHint?: string
): RegistrationState {
  if (profile.mobile_verified === false) {
    return 'phone_verification_pending';
  }

  if (profile.registration_step === 2) {
    return 'profile_pending';
  }

  const hasMissingAgreement = getPendingAgreementTypes(profile, audienceHint).length > 0;

  if (hasMissingAgreement) {
    return 'agreements_pending';
  }

  if (!profile.is_active) {
    return 'activation_pending';
  }

  return 'active';
}

export function resolveEffectiveRegistrationState(
  profile: Partial<BebopUser>,
  audienceHint?: string
): RegistrationState {
  const storedState = profile.registration_state;
  if (isRegistrationState(storedState)) {
    if (storedState === 'activation_pending' && profile.is_active) {
      return deriveRegistrationStateFromProfile(profile, audienceHint);
    }
    return storedState;
  }

  return deriveRegistrationStateFromProfile(profile, audienceHint);
}
